export default __webpack_public_path__ + "static/media/assessment-explanation-correct.85953daf.svg";